<template>
  <PrimericaBenefits
    id="learn-more"
    :display-contact-rep="true"
    :footer-content="footerContent"
    class="invlearntop"
  >
    <template v-slot:hero>
      <div class="image-box position-relative">
        <v-img alt="$t('L_with_as_little')" src="../../../assets/FamilyHavingFunAtHome1.jpg" />
        <h1 :aria-label="$t('L_with_as_little')">
          {{ $t('L_with_as_little') }}
        </h1>
      </div>
    </template>
    <template v-slot:content>
      <div class="text-h2 pl-4 pr-4 ml-4 mr-4 heading_two" :aria-label="$t('L_it_all_adds_up')">
        {{ $t('L_it_all_adds_up') }}
      </div>
      <div class="body-1 pl-4 pr-4 ml-4 mr-4">
        {{ $t('L_no_matter_how_much') }}
      </div>
      <v-container class="mt-6">
        <v-row wrap class="mt-4 mb-2">
          <v-col xs="12">
            <div v-if="selectedVideo === 0">
              <VideoPlayer
                :video-url="$t('L_high_cost_of_waiting_videoUrl')"
                :closed-caption-url="$t('L_high_cost_of_waiting_closedCaptionUrl')"
                :poster-url="$t('L_high_cost_of_waiting_posterUrl')"
              />
            </div>
            <div v-if="selectedVideo === 1">
              <VideoPlayer
                :video-url="$t('L_pay_yourself_first_videoUrl')"
                :closed-caption-url="$t('L_pay_yourself_first_closedCaptionUrl')"
                :poster-url="$t('L_pay_yourself_first_posterUrl')"
              />
            </div>
            <div v-if="selectedVideo === 2">
              <VideoPlayer
                :video-url="$t('L_rule_of_seventy_two_videoUrl')"
                :closed-caption-url="$t('L_rule_of_seventy_two_closedCaptionUrl')"
                :poster-url="$t('L_rule_of_seventy_two_posterUrl')"
              />
            </div>
            <div v-if="selectedVideo === 3">
              <VideoPlayer
                :video-url="$t('L_power_of_compound_videoUrl')"
                :closed-caption-url="$t('L_power_of_compound_closedCaptionUrl')"
                :poster-url="$t('L_power_of_compound_posterUrl')"
              />
            </div>
          </v-col>
        </v-row>
        <v-row wrap>
          <v-col xs="12" sm="6" md="4" lg="3">
            <span class="cursor-pointer body-1" @click="selectedVideo = 0">
              {{ $t('L_video_subtitle_1') }}
            </span>
          </v-col>
          <v-col xs="12" sm="6" md="4" lg="3">
            <span class="cursor-pointer body-1" @click="selectedVideo = 1">
              {{ $t('L_video_subtitle_2') }}
            </span>
          </v-col>
          <v-col xs="12" sm="6" md="4" lg="3">
            <span class="cursor-pointer body-1" @click="selectedVideo = 2">
              {{ $t('L_video_subtitle_3') }}
            </span>
          </v-col>
          <v-col xs="12" sm="6" md="4" lg="3">
            <span class="cursor-pointer body-1" @click="selectedVideo = 3">
              {{ $t('L_video_subtitle_4') }}
            </span>
          </v-col>
        </v-row>
      </v-container>
      <v-row class="body column-with-icon ml-4 mr-4 pl-4 pr-4">
        <v-col cols="12">
          <h2 class="text-h2 heading_two text-center my-6" :aria-label="$t('L_3_easy_ways')">
            {{ $t('L_3_easy_ways') }}
          </h2>
        </v-col>
        <v-col cols="2" md="2" class="float-left d-flex align-center">
          <div class="icon">
            <v-img alt="investments icon" src="../../../assets/investments/top-icon1.svg" />
          </div>
        </v-col>
        <v-col cols="10" md="10" class="float-right">
          <h3 class="text-h3" :aria-label="$t('L_plan_your_meals')">
            {{ $t('L_plan_your_meals') }}
          </h3>
          <div class="body-1">
            {{ $t('L_plan_your_meals_desc') }}
          </div>
        </v-col>
        <v-col cols="2" md="2" class="float-left d-flex align-center">
          <div class="icon">
            <v-img alt="investments icon" src="../../../assets/investments/top-icon2.svg" />
          </div>
        </v-col>
        <v-col cols="10" md="10" class="float-right">
          <h3 class="text-h3" :aria-label="$t('L_brew_your_own_coffee')">
            {{ $t('L_brew_your_own_coffee') }}
          </h3>
          <div class="body-1">
            {{ $t('L_brew_your_own_coffee_desc') }}
          </div>
        </v-col>
        <v-col cols="2" md="2" class="float-left d-flex align-center">
          <div class="icon">
            <v-img alt="investment icon" src="../../../assets/investments/top-icon3.svg" />
          </div>
        </v-col>
        <v-col cols="10" md="10" class="float-right last">
          <h3 class="text-h3" :aria-label="$t('L_ditch_cable_tv')">
            {{ $t('L_ditch_cable_tv') }}
          </h3>
          <div class="body-1">
            {{ $t('L_ditch_cable_tv_desc') }}
          </div>
          <div class="sub-text">
            {{ $t('L_20_easy_ways') }}
          </div>
        </v-col>
      </v-row>
    </template>
  </PrimericaBenefits>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import VideoComponent from '@/components/Video.vue';
import PrimericaBenefits from '@/components/PrimericaBenefits.vue';
import { mapState } from 'pinia';
import { useCustomerStore } from '@/stores/customer/customer.store';
import { COUNTRIES } from '@/shared/models/constants.models';
import VideoPlayer from '@/components/VideoPlayer/VideoPlayer.vue';

import bottomIcon1 from '@/assets/investments/bottom-icon1.svg';
import bottomIcon2 from '@/assets/investments/bottom-icon2.svg';
import bottomIcon3 from '@/assets/investments/bottom-icon3.svg';
import bottomIcon4 from '@/assets/investments/bottom-icon4.svg';
import bottomIcon5 from '@/assets/investments/bottom-icon5.svg';
import bottomIcon6 from '@/assets/investments/bottom-icon6.svg';

const componentOptions: ComponentOptions = {
  name: 'LearnMore',
  components: {
    VideoComponent,
    PrimericaBenefits,
    VideoPlayer,
  },
  data() {
    return {
      selectedVideo: 0,
      bottomIcon1,
      bottomIcon2,
      bottomIcon3,
      bottomIcon4,
      bottomIcon5,
      bottomIcon6,
    };
  },
  computed: {
    ...mapState(useCustomerStore, ['customerProfile']),
    footerContent() {
      return {
        title: this.$t(`L_pfs_investments${this.isCanadian ? '_canada' : ''}`),
        subtext: this.$t('L_securities_by_pfs'),
        subtitle: this.$t('L_helping_families'),
        cards: [
          {
            icon: bottomIcon1,
            text: this.$t(this.isCanadian ? 'L_committed_to_helping' : 'L_securities_and_exchange'),
          },
          {
            icon: bottomIcon2,
            text: this.$t('L_offers_mutual_funds'),
          },
          {
            icon: bottomIcon3,
            text: this.$t('L_has_approx_client_accounts'),
          },
          {
            icon: bottomIcon4,
            text: this.$t('L_publicly_traded'),
          },
          {
            icon: bottomIcon5,
            text: this.$t('L_primerica_awarded'),
          },
          {
            icon: bottomIcon6,
            text: this.$t('L_investment_clients'),
          },
        ],
      };
    },
    isCanadian() {
      return this.customerProfile.country === COUNTRIES.CANADA;
    },
  },
};

export default defineComponent(componentOptions);
</script>

<style lang="scss">
.invlearntop {
  margin-top: -12px 0 0 0;
}
#learn-more {
  background-color: #fff;
  margin-bottom: 1rem;
  .image-box {
    position: relative;
    h1 {
      color: #ffffff;
      font-weight: bold;
      position: absolute;
      bottom: 0;
      width: 550px;
      margin-left: 30px;
      @media only screen and (max-width: 760px) {
        font-size: 11px;
        bottom: 0px;
        width: 100%;
        margin-left: 0;
      }
    }

    .hero {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
  }

  .v-tabs {
    margin: 20px 0;
    display: flex;

    .v-tabs__bar {
      order: 1;
      margin: 5px 0 0;

      div.v-tabs__div > a.v-tabs__item {
        color: #4a4a4a !important;
        border: none;
        padding: 0;
        white-space: nowrap;
        letter-spacing: -0.2px;

        &.v-tabs__item--active {
          margin: 0 0 0;
        }
      }

      .v-tabs__slider-wrapper {
        display: none;
      }
    }

    .v-window {
      order: 0;
    }
  }

  @media only screen and (max-width: 640px) {
    .v-tabs {
      margin: 25px 0 10px;
    }
  }

  @media only screen and (max-width: 430px) {
    .column-with-icon {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }
}
</style>
